import React from 'react'
import PropTypes from 'prop-types'
// import ViewStats from './view-stats'
import TriggerAndActionCounter from './trigger-and-action-counter'
import InteractionCounters from './interaction-counters'
import ExperienceControls from './experience-controls'
import ExperienceNameAndStatus from './experience-name-and-status'

const Experience = ({
  id,
  widgetData,
  onStatusUpdate,
  canCreate,
  participantCount
}) => {
  const { name, type, status, actions, startDate, endDate } = widgetData
  return (
    <div className='col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-0'>
      <div className='br-experience portlet'>
        <ExperienceNameAndStatus
          name={name}
          status={status}
          type={type}
          startDate={new Date(startDate).toDateString()}
          endDate={new Date(endDate).toDateString()}
        />

        <div className='row'>
          <div className='col-sm-8'>
            <TriggerAndActionCounter actions={actions} />
          </div>
          <div className='col-sm-4'>
            {canCreate &&
            (type === 'MOSAIC' ||
              type === 'REMINDER' ||
              type === 'MENTION' ||
              type === 'TWITTER_THREADVENTURE' ||
              type === 'INSTAGRAM_COMPETITION' ||
              type === 'FACEBOOK_COMPETITION' ||
              type === 'FACEBOOK_REMINDER' ||
              type === 'FACEBOOK_RECURRING_REMINDER' ||
              type === 'FACEBOOK_COUPON' ||
              type === 'INSTAGRAM_COUPON') ? (
              <ExperienceControls // eslint-disable-line
                id={id}
                type={type}
                status={status}
                onStatusUpdate={onStatusUpdate}
              />
            ) : null}
          </div>
        </div>

        <hr />

        <div className='br-experience-stats row'>
          <InteractionCounters
            total={0}
            today={0}
            participantCount={participantCount}
          />

          {/* Hiding this for now but hiding as we're not using it for now
          Commenting out instead of deleting to keep it as a marker of where it was included */}
          {/* <div className='col-xs-4'>
            <ViewStats />
          </div> */}
        </div>
      </div>
    </div>
  )
}

Experience.propTypes = {
  id: PropTypes.string.isRequired,
  widgetData: PropTypes.object.isRequired,
  onStatusUpdate: PropTypes.func.isRequired,
  canCreate: PropTypes.bool.isRequired,
  participantCount: PropTypes.number.isRequired
}

Experience.displayName = 'ExperienceComponent'

export default Experience



// WEBPACK FOOTER //
// ./src/pages/my-experiences/experience/index.js